export default __webpack_public_path__ + "images/image7.6ad09d51.png";